import { createReducer, on, Action } from '@ngrx/store';
import { ThemeUiActions } from '../actions';
import { ThemeName } from '../actions/theme-ui.actions';

const LIGHT_THEME: ThemeName = 'azdhs';
const DARK_THEME: ThemeName = 'azdhs-dark';

export interface ThemeState {
  theme: ThemeName;
  userOverride: boolean;
}

const initialState: ThemeState = {
  theme: LIGHT_THEME,
  userOverride: false,
};

export const ThemeStateReducer = createReducer(
  initialState,
  on(ThemeUiActions.SetTheme, (state, { theme }) => {
    return { ...state, theme, userOverride: true };
  }),
  on(ThemeUiActions.ToggleTheme, (state) => {
    return {
      ...state,
      theme: state.theme === DARK_THEME ? LIGHT_THEME : DARK_THEME,
      userOverride: true,
    };
  }),
  on(ThemeUiActions.SetSystemPreference, (state, { prefersDark }) => {
    // The OS preference only drives the theme until the user makes an explicit choice.
    if (state.userOverride) {
      return state;
    }
    return { ...state, theme: prefersDark ? DARK_THEME : LIGHT_THEME };
  })
);

export function ThemeReducer(state: ThemeState = initialState, action: Action): ThemeState {
  return ThemeStateReducer(state, action);
}
